
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/player/sdk/embed",
      function () {
        return require("private-next-pages/player/sdk/embed/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/player/sdk/embed"])
      });
    }
  